<script setup lang="ts"></script>

<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.9999 22C17.5227 22 21.9999 17.5228 21.9999 12C21.9999 6.47715 17.5227 2 11.9999 2C6.47703 2 1.99988 6.47715 1.99988 12C1.99988 17.5228 6.47703 22 11.9999 22Z"
    />
    <path d="M8 8L16 16" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M8 16L16 8" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>

<style scoped lang="scss"></style>
